import React from 'react';

export const IsMobileCtx = React.createContext({ isMobile: false });
